import { render, staticRenderFns } from "./System.vue?vue&type=template&id=fca5db98&scoped=true&"
import script from "./System.vue?vue&type=script&lang=js&"
export * from "./System.vue?vue&type=script&lang=js&"
import style0 from "./System.vue?vue&type=style&index=0&id=fca5db98&prod&lang=scss&scoped=true&"
import style1 from "./System.vue?vue&type=style&index=1&id=fca5db98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca5db98",
  null
  
)

export default component.exports